// extracted by mini-css-extract-plugin
export default {"contIntro":"index_contIntro_-zl71"};